import { render, staticRenderFns } from "./PracticeDetailHeader.vue?vue&type=template&id=e07944fe"
import script from "./PracticeDetailHeader.vue?vue&type=script&lang=js"
export * from "./PracticeDetailHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports